const calender = () =>
  import(/* webpackChunkName: "chunk-calendar-svg" */ "./calendarI");
const lock = () => import(/* webpackChunkName: "chunk-lock-svg" */ "./lock");
const phone = () =>
  import(/* webpackChunkName: "chunk-phone-svg" */ "./phone-call");
const envelope = () =>
  import(/* webpackChunkName: "chunk-envelope-svg" */ "./envelope");

const checkSVG = () =>
  import(/* webpackChunkName: "chunk-double-check-svg" */ "./double-check");
const solidDirection = () =>
  import(
    /* webpackChunkName: "chunk-solidDirection-svg" */ "./get-directions-button"
  );
const directions = () =>
  import(/* webpackChunkName: "chunk-directions-svg" */ "./Directions");
const starSVG = () => import(/* webpackChunkName: "chunk-star-svg" */ "./star");
const starOutlineSVG = () =>
  import(/* webpackChunkName: "chunk-star-svg" */ "./star-outline");
const patientAllSVG = () =>
  import(/* webpackChunkName: "chunk-patientAll-svg" */ "./patientAll");
const checkSolid = () =>
  import(/* webpackChunkName: "chunk-checkSolid-svg" */ "./checkSolid");
const Bulb = () => import(/* webpackChunkName: "chunk-bulb-svg" */ "./bulb");
const MedicalCertificate = () =>
  import(
    /* webpackChunkName: "chunk-MedicalCertificate-svg" */ "./MedicalCertificate"
  );
const PdfIcon = () =>
  import(/* webpackChunkName: "chunk-pdf-icon-svg" */ "./pdf-icon");
const PDF = () => import(/* webpackChunkName: "chunk-pdf-svg" */ "./pdf");
const FlagIcon = () =>
  import(/* webpackChunkName: "chunk-flag-icon-svg" */ "./flagSolid");
const downloadSVG = () =>
  import(/* webpackChunkName: "chunk-download-svg" */ "./download");
const printSVG = () =>
  import(/* webpackChunkName: "chunk-print-svg" */ "./printer");
const undertreateSVG = () =>
  import(
    /* webpackChunkName: "chunk-undertreatement-svg" */ "./undertreatement"
  );
const fitnessSVG = () =>
  import(/* webpackChunkName: "chunk-fitness-svg" */ "./fitness");
const blankfileSVG = () =>
  import(/* webpackChunkName: "chunk-blankfile-svg" */ "./blankfile");
const contactBook = () =>
  import(/* webpackChunkName: "chunk-contact-book-svg" */ "./contact-book");
const chat = () => import(/* webpackChunkName: "chunk-chat-svg" */ "./chat");
const hospital = () =>
  import(/* webpackChunkName: "chunk-hospital-svg" */ "./hospital");
const hospitalClinic = () =>
  import(/* webpackChunkName: "chunk-hospital-svg" */ "./hospitalClinic");

const seller = () =>
  import(/* webpackChunkName: "chunk-seller-svg" */ "./seller");
const stockist = () =>
  import(/* webpackChunkName: "chunk-stockist-svg" */ "./stockist");
const insurance = () =>
  import(/* webpackChunkName: "chunk-insurance-svg" */ "./insurance");
const court = () => import(/* webpackChunkName: "chunk-court-svg" */ "./court");
const ClinicIco = () =>
  import(/* webpackChunkName: "chunk-clinic-icon-svg" */ "./clinic-icon");
const folderSVG = () =>
  import(/* webpackChunkName: "chunk-folder-svg" */ "./folder");
const leftQuote = () =>
  import(/* webpackChunkName: "chunk-left-quote-svg" */ "./left-quote");
const rightArrow = () =>
  import(/* webpackChunkName: "chunk-right-arrow-svg" */ "./right-arrow");
const backsvg = () =>
  import(/* webpackChunkName: "chunk-back-svg" */ "./backsvg");
const backward = () =>
  import(/* webpackChunkName: "chunk-backward-svg" */ "./backward");
const userDouble = () =>
  import(/* webpackChunkName: "chunk-userDouble-svg" */ "./userDouble");
const settings = () =>
  import(/* webpackChunkName: "chunk-settings-svg" */ "./settings");
const privacyPolicy = () =>
  import(/* webpackChunkName: "chunk-privacy-policy-svg" */ "./privacy-policy");
const megaphone = () =>
  import(/* webpackChunkName: "chunk-megaphone-svg" */ "./megaphone");
const qa = () => import(/* webpackChunkName: "chunk-qa-svg" */ "./qa");
const lifePreserver = () =>
  import(/* webpackChunkName: "chunk-life-preserver-svg" */ "./life-preserver");
const login = () => import(/* webpackChunkName: "chunk-login-svg" */ "./login");
const exit = () => import(/* webpackChunkName: "chunk-exit-svg" */ "./exit");
const logout = () =>
  import(/* webpackChunkName: "chunk-exit-svg" */ "./logout");
const about = () => import(/* webpackChunkName: "chunk-about-svg" */ "./about");
const customerService = () =>
  import(
    /* webpackChunkName: "chunk-customerService-svg" */ "./customerService"
  );
const onlineStore = () =>
  import(/* webpackChunkName: "chunk-customerService-svg" */ "./online-store");
const iIcon = () =>
  import(
    /* webpackChunkName: "chunk-information-button-svg" */ "./information-button"
  );
const infoIcon = () =>
  import(/* webpackChunkName: "chunk-info-icon-svg" */ "./info-icon");
const editSVG = () =>
  import(
    /* webpackChunkName: "chunk-editBorderPencil-svg" */ "./editBorderPencil"
  );
const favouritesSVG = () =>
  import(/* webpackChunkName: "chunk-favourites-svg" */ "./favourites");
const userSVG = () => import(/* webpackChunkName: "chunk-user-svg" */ "./user");
const party = () => import(/* webpackChunkName: "chunk-party-svg" */ "./party");
const packageSVG = () =>
  import(/* webpackChunkName: "chunk-package-svg" */ "./package");
const interview = () =>
  import(/* webpackChunkName: "chunk-interview-svg" */ "./interview");
const service = () =>
  import(/* webpackChunkName: "chunk-service-svg" */ "@/SVG/service");
const likebkg = () =>
  import(/* webpackChunkName: "chunk-likebkg-svg" */ "@/SVG/likebkg");
const shoppingCart = () =>
  import(/* webpackChunkName: "chunk-shoppingCart-svg" */ "@/SVG/shoppingCart");
const location = () =>
  import(/* webpackChunkName: "chunk-location-svg" */ "@/SVG/location");
const ticket = () =>
  import(/* webpackChunkName: "chunk-ticket-svg" */ "@/SVG/ticket");
const likehrt = () =>
  import(/* webpackChunkName: "chunk-likehrt-svg" */ "@/SVG/likehrt");
const logo = () =>
  import(/* webpackChunkName: "chunk-logo-svg" */ "@/SVG/logo");
const medicationSVG = () =>
  import(/* webpackChunkName: "chunk-medication-svg" */ "@/SVG/managePassword");
const OPDSVG = () =>
  import(/* webpackChunkName: "chunk-security-svg" */ "@/SVG/security");
const pastHistorySVG = () =>
  import(/* webpackChunkName: "chunk-pastHistory-svg" */ "@/SVG/manageProfile");
const vaccineSVG = () =>
  import(/* webpackChunkName: "chunk-vaccine-svg" */ "@/SVG/requestedLogInfo");
const virusSVG = () =>
  import(/* webpackChunkName: "chunk-virus-svg" */ "@/SVG/virus");
const deadbodySVG = () =>
  import(/* webpackChunkName: "chunk-dead-body-svg" */ "@/SVG/dead-body");
const procedureSVG = () =>
  import(/* webpackChunkName: "chunk-procedure-svg" */ "@/SVG/procedure");
const adviceProcedureSVG = () =>
  import(/* webpackChunkName: "chunk-health-check-svg" */ "@/SVG/health-check");
const wrongAccess = () =>
  import(/* webpackChunkName: "chunk-wrong-access-svg" */ "@/SVG/wrong-access");
const linkSVG = () =>
  import(/* webpackChunkName: "chunk-link-svg" */ "@/SVG/link");
const disconnectedChains = () =>
  import(
    /* webpackChunkName: "chunk-disconnectedChains-svg" */ "@/SVG/disconnectedChains"
  );
const moneySVG = () =>
  import(/* webpackChunkName: "chunk-money-svg" */ "@/SVG/walletmoney1");
const billSVG = () =>
  import(/* webpackChunkName: "chunk-bill-svg" */ "@/SVG/walletbill");
const money2SVG = () =>
  import(/* webpackChunkName: "chunk-money2-svg" */ "@/SVG/walletmoney2");
const incomeSvg = () =>
  import(/* webpackChunkName: "chunk-income-svg" */ "@/SVG/accountIncome");
const successcheckSVG = () =>
  import(/* webpackChunkName: "chunk-success-svg" */ "@/SVG/success");
const walletSolid = () =>
  import(/* webpackChunkName: "chunk-wallet-svg" */ "@/SVG/walletSolid");
const printerSolid = () =>
  import(/* webpackChunkName: "chunk-printerSolid-svg" */ "@/SVG/printerSolid");
const locationSVG = () =>
  import(/* webpackChunkName: "chunk-location2-svg" */ "@/SVG/location");
const rightarrowSVG = () =>
  import(/* webpackChunkName: "chunk-rightarrow-svg" */ "@/SVG/nextsvg");
const emailSVG = () =>
  import(/* webpackChunkName: "chunk-email-svg" */ "./email-icon");
const filterSVG = () =>
  import(/* webpackChunkName: "chunk-filter-svg" */ "@/SVG/filter");
const testSVG = () =>
  import(/* webpackChunkName: "chunk-test-svg" */ "@/SVG/test");
const trivendrumSVG = () =>
  import(/* webpackChunkName: "chunk-trivendrum-svg" */ "@/SVG/trivendrum");
const whochartSVG = () =>
  import(/* webpackChunkName: "chunk-whochart-svg" */ "@/SVG/whochart");
const headphoneSVG = () =>
  import(/* webpackChunkName: "chunk-headphones-svg" */ "@/SVG/headphones");
const alarmheadSVG = () =>
  import(/* webpackChunkName: "chunk-alarm-head-svg" */ "@/SVG/alarm_head");
const notificationSVG = () =>
  import(/* webpackChunkName: "chunk-notification-svg" */ "@/SVG/notification");

const downSVG = () =>
  import(
    /* webpackChunkName: "chunk-down-arrow-solid-svg" */ "@/SVG/down-arrow-solid"
  );
const microphoneSolid = () =>
  import(
    /* webpackChunkName: "chunk-microphoneSolid-svg" */ "@/SVG/microphoneSolid"
  );
const microphoneOff = () =>
  import(
    /* webpackChunkName: "chunk-microphone-off-svg" */ "@/SVG/microphone-off"
  );
const videoCamera = () =>
  import(/* webpackChunkName: "chunk-video-camera-svg" */ "@/SVG/video-camera");
const videoCameraSolid = () =>
  import(
    /* webpackChunkName: "chunk-video-camera-solid-svg" */ "@/SVG/video-camera-solid"
  );
const calculatorSVG = () =>
  import(/* webpackChunkName: "chunk-calculator-svg" */ "@/SVG/calculator");
const fileSVG = () =>
  import(/* webpackChunkName: "chunk-file-svg" */ "@/SVG/file");
const workingDiagnosisSVG = () =>
  import(
    /* webpackChunkName: "chunk-working-diagnosis-svg" */ "@/SVG/Working_Diagnosis"
  );
const pdfSVG = () =>
  import(/* webpackChunkName: "chunk-pdfFile-svg" */ "@/SVG/pdfFile");
const attachmentSVG = () =>
  import(/* webpackChunkName: "chunk-attachment-svg" */ "@/SVG/attachment");
const CallIconSVG = () =>
  import(/* webpackChunkName: "chunk-call-icon-svg" */ "@/SVG/call-icon");
const ChatBubbleSVG = () =>
  import(/* webpackChunkName: "chunk-chat-bubble-svg" */ "@/SVG/chat-bubble");
const euthanasiaSVG = () =>
  import(/* webpackChunkName: "chunk-euthanasia-svg" */ "@/SVG/euthanasia");
const healthinsuranceSVG = () =>
  import(
    /* webpackChunkName: "chunk-health-insurance-svg" */ "@/SVG/health-insurance"
  );
const keySVG = () =>
  import(/* webpackChunkName: "chunk-key-svg" */ "@/SVG/key");
const privacySVG = () =>
  import(/* webpackChunkName: "chunk-privacy-svg" */ "@/SVG/privacy");
const fileLockSVG = () =>
  import(/* webpackChunkName: "chunk-fileLock-svg" */ "@/SVG/fileLock");
const signatureSVG = () =>
  import(/* webpackChunkName: "chunk-signature-svg" */ "@/SVG/signature");
const securitySVG = () =>
  import(/* webpackChunkName: "chunk-security-svg" */ "@/SVG/security2");
const databaseSVG = () =>
  import(/* webpackChunkName: "chunk-database-svg" */ "@/SVG/database");
const manageProfilesettingsSVG = () =>
  import(
    /* webpackChunkName: "chunk-manageProfilesettings-svg" */ "@/SVG/manageProfilesettings"
  );
/*........................................................... subscription icons ......................................................... */
const giftBox = () =>
  import(/* webpackChunkName: "chunk-gift-box-svg" */ "./gift-box");
const subscriptionMonthly = () =>
  import(
    /* webpackChunkName: "chunk-subscriptionMonthly-svg" */ "@/SVG/subscriptionMonthly"
  );
const subscriptionHalfYear = () =>
  import(
    /* webpackChunkName: "chunk-subscriptionHalfYear-svg" */ "@/SVG/subscriptionHalfYear"
  );
const subscriptionYearly = () =>
  import(
    /* webpackChunkName: "chunk-subscriptionYearly-svg" */ "@/SVG/subscriptionYearly"
  );
const subscriptionGiftBox = () =>
  import(
    /* webpackChunkName: "chunk-subscriptionGiftBox-svg" */ "@/SVG/subscriptionGiftBox"
  );
/*........................................................... end subscription icons ......................................................... */
/*........................................................... role icons ......................................................... */
const doctor = () =>
  import(/* webpackChunkName: "chunk-doctor-svg" */ "./doctor");
const ambulance = () =>
  import(/* webpackChunkName: "chunk-ambulance-svg" */ "./ambulance");
const blood = () => import(/* webpackChunkName: "chunk-blood-svg" */ "./blood");
const patient = () =>
  import(/* webpackChunkName: "chunk-patient-svg" */ "./patient");
const pharmacyRecord = () =>
  import(/* webpackChunkName: "chunk-patient-svg" */ "./medication");
/*........................................................... end role icons ......................................................... */
/*............................................... media icons .............................................................. */
const apple = () =>
  import(/* webpackChunkName: "chunk-apple-svg" */ "@/SVG/apple");
const android = () =>
  import(/* webpackChunkName: "chunk-android-logo-svg" */ "@/SVG/android-logo");
const whatsappline = () =>
  import(/* webpackChunkName: "chunk-whatsappline-svg" */ "./whatsappline");
const instagramSVG = () =>
  import(/* webpackChunkName: "chunk-instagram-svg" */ "@/SVG/instagram");
const twitterSVG = () =>
  import(
    /* webpackChunkName: "chunk-twitter-svg" */ "@/SVG/twitter-black-shape"
  );
const facebookSVG = () =>
  import(/* webpackChunkName: "chunk-facebook-svg" */ "@/SVG/facebookicon");
const facebook = () => import("@/SVG/facebook");
const whatsapp = () =>
  import(/* webpackChunkName: "chunk-whatsapp-svg" */ "@/SVG/whatsapp");
const daySVG = () =>
  import(/* webpackChunkName: "chunk-whatsapp-svg" */ "@/SVG/day");
const twitterLogo = () => import("@/SVG/twitterLogo");
const linkedin = () => import("@/SVG/linkedin");
const bloggerLogo = () => import("@/SVG/bloggerLogo");
/*........................................................ end media icons ................................................ */
/*.................................................... action icons ...................................................... */
const sendSolid = () =>
  import(/* webpackChunkName: "chunk-send-svg" */ "./sendSolid.vue");
const send = () =>
  import(/* webpackChunkName: "chunk-send-svg" */ "./send.vue");
const watchSVG = () =>
  import(/* webpackChunkName: "chunk-watch-svg" */ "./watch.vue");
const searchSVG = () =>
  import(/* webpackChunkName: "chunk-search-svg" */ "./search");
const menuSVG = () =>
  import(/* webpackChunkName: "chunk-menu-svg" */ "./horizontalLines");
const verticalDots = () =>
  import(/* webpackChunkName: "chunk-vertical-dots-svg" */ "./vertical-dots");
const crossSolidSVG = () =>
  import(/* webpackChunkName: "chunk-crossSolid-svg" */ "./crossSolid");
const cancelSolid = () =>
  import(/* webpackChunkName: "chunk-cancelSolid-svg" */ "@/SVG/cancelSolid");
const shareSVG = () =>
  import(/* webpackChunkName: "chunk-share-icon-svg" */ "@/SVG/share-icon");
const deleteSVG = () =>
  import(/* webpackChunkName: "chunk-delete-svg" */ "@/SVG/delete");
const alert = () =>
  import(/* webpackChunkName: "chunk-red-alert-svg" */ "@/SVG/red-alert");
const verticalMenuSVG = () =>
  import(
    /* webpackChunkName: "chunk-verticalMenu-svg" */ "@/SVG/vertical-dots"
  );
const saveSVG = () =>
  import(/* webpackChunkName: "chunk-floppy-disk-svg" */ "@/SVG/floppy-disk");
const menudots = () =>
  import(/* webpackChunkName: "chunk-menudots-svg" */ "./verticaldoysborder");
const crossSVG = () =>
  import(/* webpackChunkName: "chunk-cross-svg" */ "@/SVG/cross");
/*........................................................... end action icons ......................................................... */
/*........................................................... dashboard icons ......................................................... */
const shoppingCartSVG = () =>
  import(/* webpackChunkName: "chunk-speak-svg" */ "@/SVG/speak");
const gallerySVG = () =>
  import(/* webpackChunkName: "chunk-gallery-svg" */ "@/SVG/gallery");
const alarmSVG = () =>
  import(/* webpackChunkName: "chunk-alarm-svg" */ "@/SVG/alarm");
const prescription = () =>
  import(/* webpackChunkName: "chunk-prescription-svg" */ "./prescription");
const walletSVG = () =>
  import(/* webpackChunkName: "chunk-wallet-svg" */ "@/SVG/wallet");
const stationaryBikeSVG = () =>
  import(
    /* webpackChunkName: "chunk-stationary-bike-svg" */ "@/SVG/stationary-bike"
  );
const reviewsSVG = () =>
  import(/* webpackChunkName: "chunk-reviews-svg" */ "@/SVG/reviews");
const calenderSVG = () =>
  import(/* webpackChunkName: "chunk-calendar-svg" */ "@/SVG/calendar");
const reportsSVG = () =>
  import(/* webpackChunkName: "chunk-reports-svg" */ "@/SVG/reports");
const downArrow = () =>
  import(/* webpackChunkName: "chunk-down-arrow-svg" */ "@/SVG/down-arrow");
const onlineConsultationSVG = () =>
  import(
    /* webpackChunkName: "chunk-online-consultation-svg" */ "@/SVG/online-consultation"
  );
const documentsSVG = () =>
  import(/* webpackChunkName: "chunk-documents-svg" */ "./documents");
const ordersSVG = () =>
  import(/* webpackChunkName: "chunk-orders-svg" */ "@/SVG/orders");
const lefrArrowSVG = () =>
  import(
    /* webpackChunkName: "chunk-left-arrow-svg" */ "@/SVG/left-arrow-double"
  );
const medicalRecord = () =>
  import(/* webpackChunkName: "chunk-medicalRecord-svg" */ "./medicalRecord");
const homeSVG = () =>
  import(/* webpackChunkName: "chunk-home-svg" */ "@/SVG/home");
const flagSVG = () =>
  import(/* webpackChunkName: "chunk-flagoutline-svg" */ "@/SVG/flagoutline");
const medicalAccountsSVG = () =>
  import(
    /* webpackChunkName: "chunk-medicalAccounts-svg" */ "@/SVG/MedicalAccounts"
  );
const dashboardFavourites = () =>
  import(
    /* webpackChunkName: "chunk-dashboardFavourites-svg" */ "@/SVG/dashboardFavourites"
  );
const homeVisitSVG = () =>
  import(/* webpackChunkName: "chunk-housevisit-svg" */ "@/SVG/housevisit");
const mygallery = () =>
  import(/* webpackChunkName: "chunk-mygallery-svg" */ "@/SVG/mygallery");
const patientgallery = () =>
  import(
    /* webpackChunkName: "chunk-patientgallery-svg" */ "@/SVG/patientgallery"
  );
const eventsSVG = () =>
  import(/* webpackChunkName: "chunk-events-svg" */ "@/SVG/events");
const ipdSVG = () =>
  import(/* webpackChunkName: "chunk-ipd-svg" */ "@/SVG/ipd");
const dependentSVG = () =>
  import(/* webpackChunkName: "chunk-dependent-svg" */ "@/SVG/dependent");
const personelSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/personel");
const shoppingBagSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/shopping-bag");
const leftArrowCircleSVG = () =>
  import(
    /* webpackChunkName: "chunk-personel-svg" */ "@/SVG/left-arrow-circle"
  );
const leftArrowCircleSolidSVG = () =>
  import(
    /* webpackChunkName: "chunk-personel-svg" */ "@/SVG/left-arrow-circle-solid"
  );
const rightArrowCircleSVG = () =>
  import(
    /* webpackChunkName: "chunk-personel-svg" */ "@/SVG/right-arrow-circle"
  );
const rightArrowCircleSolidSVG = () =>
  import(
    /* webpackChunkName: "chunk-personel-svg" */ "@/SVG/right-arrow-circle-solid"
  );
/*........................................................... end dashboard icons ......................................................... */
const sharingSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/sharing");
const ReferAndEarnSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/Refer-and-earn");
const oxygenSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/oxygen");
const digitalSignatureSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/digitalSignature");

const privacydocSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/document");
const requestlogInfoSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/log");
const manageProfileSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/profile");
const subscriptionBoxSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/subscription");
const blogSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/blog");
const dependentsSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/dependents.vue");
const clone = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/clone");
const totalPendingCenterSVG = () =>
  import(
    /* webpackChunkName: "chunk-personel-svg" */ "@/SVG/total_pending_center"
  );
const expiredCenterSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/expired_center");
const subscribedCenterSVG = () =>
  import(
    /* webpackChunkName: "chunk-personel-svg" */ "@/SVG/subscribed_center"
  );
const totalAcceptedCenterSVG = () =>
  import(
    /* webpackChunkName: "chunk-personel-svg" */ "@/SVG/total_accepted_center"
  );
const totalUnsubscribedCenterSVG = () =>
  import(
    /* webpackChunkName: "chunk-personel-svg" */ "@/SVG/total_unsubscribed_center"
  );

const heartWithPlus = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/health-care");
const hospitalBed = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/hospital-bed");
const checkarrowSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/check");
const userblockSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/userblock");
const filterblocksSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/filterblock");
const arrowrightSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/arrow-right");
const patientleftarrowSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/patientleftarrow");
const patientrightarrowSVG = () =>
  import(
    /* webpackChunkName: "chunk-personel-svg" */ "@/SVG/patientrightarrow"
  );

const hairfallSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/hairloss");
const cardioSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/cardio");
const periodSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/period");

const backpainSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/backpain");

const abdomenSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/abdomen");
const depressionSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/depression2");
const aciditygasSvg = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/acidity-gas");

//new colored icons added

const colorCalendarSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/color-calendar");

const colorOnlineSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/color-online");

const colorMedicalSVG = () =>
  import(
    /* webpackChunkName: "chunk-personel-svg" */ "@/SVG/medical-prescription"
  );
const colorhealthSVG = () =>
  import(
    /* webpackChunkName: "chunk-personel-svg" */ "@/SVG/color-health-check"
  );

const colorMedicalHistorySVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/medical-history");

const colorGallerySVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/color-gallery");

const colorBloggerSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/blogger");

const colorFlagSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/flag");

const colorMedicalAssistanceSVG = () =>
  import(
    /* webpackChunkName: "chunk-personel-svg" */ "@/SVG/medical-assistance"
  );
const colorTestSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/search-patient");
const colorWalletSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/color-wallet");
const colorTemplateSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/template");
const colorRatingSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/color-rating");
const colorBloodSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/colorblood");

const colorPharmacySVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/colorpharmacy");

const colorTestsSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/colortest");
const colorDoctorSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/colordoctor");
const colorDiagnosticSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/colordiagnostics");
const colorAmbulanceSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/colorambulance");
const newBlood = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newblood");
const newHospital = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newhospital");
const colorPersonalSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/colorpersonal");

const colorShopCartSVG = () =>
  import(
    /* webpackChunkName: "chunk-personel-svg" */ "@/SVG/color-shopping-cart"
  );

const colorGrievanceSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/color-grievance");

const colorWalletTransSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/colorwalletTrans");

const colorEnrolledSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/colorEnrolled");

const colorcampaignTransSVG = () =>
  import(
    /* webpackChunkName: "chunk-personel-svg" */ "@/SVG/colorcampaignTrans"
  );

const colorfavouriteSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/colorfavourite");

const myGallerySVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/my-gallery");

const patientGallerySVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/patient-gallery");

const homeTabSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/home-tab");
const colordependentSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/colordependent");

const editIconSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/edit");

const colorWardSVG = () =>
  import(/* webpackChunkName: "chunk-ward-svg" */ "@/SVG/color-ward");

const colorCenterSVG = () =>
  import(/* webpackChunkName: "chunk-centre-svg" */ "@/SVG/color-center");

const colorOwnerSVG = () =>
  import(/* webpackChunkName: "chunk-owner-svg" */ "@/SVG/color-owner");

const LoginImage = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "./loginImage");
const dotImage = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "./dot");

const colorTeamworkSVG = () =>
  import(/* webpackChunkName: "chunk-teamwork-svg" */ "@/SVG/teamwork");

const newLoginSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/009-account");

const newDocumentSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/documentNew");

const newHelpSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/help");

const newNotificationSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/notificationNew");

const newPolicySVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/policy");

const newPromotionSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/promotion");

const newSettingSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/settingsNew");

const newTCSVG = () =>
  import(
    /* webpackChunkName: "chunk-personel-svg" */ "@/SVG/terms-and-conditions"
  );

const newGuideSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/user-guide");

const newOtherSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/parents");

const newManSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/businessmanNew");

const newWomenSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/businesswomanNew");

// ==========================================================
// new center dashboard icons
const newPendingSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/changePending");

const newSubscribedSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/changeSubscribed");

const newExpiredSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/changeExpired");

const newAcceptedSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/changeAccepted");

const newUnSubscribedSVG = () =>
  import(
    /* webpackChunkName: "chunk-personel-svg" */ "@/SVG/changeUnsubscribed"
  );
const newCompletedSVG = () =>
  import(/* webpackChunkName: "chunk-personel-svg" */ "@/SVG/changeCompleted");

const newFAQSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/faq");

const onboardingSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/onboarding");

const newSubSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-subscription");

const newDocIconSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/doc_icon");

const newQrCode = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/qr-code");
const newSignature = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newsignature");

const newServer = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newserver");

const newManagePassword = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newpassword");

const newSettings = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newsettings");

const newSubscription = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newsubscription");

const newrequestInfo = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newrequestInfo");

const newplan = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newplan");

const newpremium = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newpremium");

const newsecurity = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newsecurity");

const newsubcriptionmonthly = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newsubcriptionmonthly");

const newsubcriptionhalf = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newsubscriptionhalf");

const newsubcriptionyearly = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newsubscriptionyearly");

const newpdf = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newpdf");

const newhealthpackage = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-health-package");
const newgallerybox = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/gallerybox");
const newpatientdead = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/patient-dead");
const newOPD = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/opd");
const newMedicalCertificate = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/medical-certificate");
const newMedications = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/medications");
const newMedicalHistory = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-medical-history");

const payPerUse = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/pay-per-use");
const newExcel = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-excel");
const newEmptyPayPerUse = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/empty-pay-per-use");
// const newEmptyPayVue = () =>
//   import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/empty-pay");
import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-medical-history");

const newMedicalDiagnosis = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/medical-diagnosis");
const newProcedure = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-procedure");

const sharingNew = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/sharingNew");

const newMR = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-MR");
const newVisitor = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-visitor");
const newImmediateOPD = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/immediate-OPD");
const newColorFitness = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newColorFitnes");
const newColorCustom = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-custom");
const newColorTreatment = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-under-treatment");

const vaccineNSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/vaccine");

const paymentHistorySVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/audit");

const newShowCalendarSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newshowcalendar");

const newWaitingArrowSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/waitingDown");

const newdesignDoctorSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-design-doctor");
const newdesignPharmacySVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-design-pharmacy");
const newdesignDiagnosticSVG = () =>
  import(
    /* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-design-diagnostice"
  );
const newdesignAmbulanceSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-design-ambulance");
const newdesignBloodbankSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-design-blood");
const newdesignSalesServiceSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-design-service");
const newdesignHospitalSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-design-hospital");

const newNoDataSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-no-data");
const newPageNotFoundSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-page-not-found");
const switchParentSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/switch-to-parent");
const newComingSoonSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newComingSoon");
import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/switch-to-parent");
const newEmptySVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newEmpty");
const newColorUploadSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-color-upload");
const newCapturePresctionSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/camera");

const onlineShopSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/online-shop");

const team2SVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/team2");

const billLinkSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newlink");

const featureSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-feature");
const newRefreshSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-refresh");

const colorCalcSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/color-calculator");
const questionSVG = () =>
  import(/* webpackChunkName: "question-svg" */ "@/SVG/question");
const newVerifyOtpSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-verify-otp");
const newAlertSVG = () =>
  import(/* webpackChunkName: "OPD" */ "@/SVG/new-alert");
const dangerAlertSVG = () =>
  import(/* webpackChunkName: "OPD" */ "@/SVG/dangerAlert");
const warningSVG = () => import(/* webpackChunkName: "OPD" */ "@/SVG/warning");
const newCOC = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newCOC");

const newAB = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/newAB");

const newAlliedBlack = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-allied-black");

const newCOCSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/COC");

const newAlliedBlackShape = () =>
  import(
    /* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-allied-black-shape"
  );
const newAlliedColorShape = () =>
  import(
    /* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-allied-color-shape"
  );

const newAlliedBlackIcon = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-allied-black-icon");

const newAppointList = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-appoint-list");

const newAppointActiveList = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-appt-active-list");

const newAppointActiveCalendar = () =>
  import(
    /* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-appt-active-calendar"
  );

const newAllergy = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/allergy");

const newBlackDoc = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-black-doc");

const newEud = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-eud");

const newAppropriate = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-repo");

const newOrganDonor = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/organ-donor");

const newZoomInSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-zoom-in");

const newZoomOutSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-zoom-out");

const conversation = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/conversation");
const groupChat = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/group-chat");
const teamChat = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/teamChat");
const profilechat = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/profilechat");
const newNetworkSVG = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/network");

const newCurrentBooking = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-current-booking");

const newCompletedBooking = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-com-booking");

const newCancelledBooking = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/new-cancelled-booking");
const group1 = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/group1");
const writtenConversation = () =>
  import(
    /* webpackChunkName: "chunk-faq-svg" */ "@/SVG/written-conversation-speech-bubble-with-letter-i-inside-of-information-for-interface"
  );
const information = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/information");

const colorDoctor = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/color-doctor");
const colorPharmacy = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/color-pharmacy");
const colorDiagnostics = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/color-diagnostics");

const colorHospital = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/color-hospital");
const colorBlood = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/color-blood");
const colorAmbulance = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/color-ambulance");
const group1405 = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/Group1405");
const group1420 = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/Group1420");
const group1984 = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/Group1984");
const drugSvg = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/drug");
const medicineSvg = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/medicine");
const searchMedicinePill = () =>
  import(/* webpackChunkName: "chunk-faq-svg" */ "@/SVG/search-medicine-pill");
  const emptyMedicineSVG = () =>
  import(/* webpackChunkName: "emptyMedicineSVG" */ '@/SVG/empty-medicine.vue')
const newPharmacySearchSVG = () =>
  import(
    /* webpackChunkName: "new_pharmacy_black" */ "@/SVG/new_pharmacy_black"
  );
// ==========================================================

let svgRegistries = {
  sendSvg: send,
  sendSolid: sendSolid,
  watchSVG: watchSVG,
  searchSVG: searchSVG,
  calender: calender,
  menuSVG: menuSVG,
  lock: lock,
  phone: phone,
  envelope: envelope,
  verticalDots: verticalDots,
  crossSolidSVG: crossSolidSVG,
  checkSVG: checkSVG,
  solidDirection: solidDirection,
  directions: directions,
  starSVG: starSVG,
  patientAllSVG: patientAllSVG,
  checkSolid: checkSolid,
  Bulb: Bulb,
  MedicalCertificate: MedicalCertificate,
  PdfIcon: PdfIcon,
  PDF: PDF,
  FlagIcon: FlagIcon,
  downloadSVG: downloadSVG,
  printSVG: printSVG,
  menudots: menudots,
  undertreateSVG: undertreateSVG,
  fitnessSVG: fitnessSVG,
  blankfileSVG: blankfileSVG,
  documentsSVG: documentsSVG,
  contactBook: contactBook,
  doctor: doctor,
  patient: patient,
  chat: chat,
  ambulance: ambulance,
  blood: blood,
  hospital: hospital,
  prescription: prescription,
  medicalRecord: medicalRecord,
  seller: seller,
  stockist: stockist,
  insurance: insurance,
  court: court,
  ClinicIco: ClinicIco,
  folderSVG: folderSVG,
  leftQuote: leftQuote,
  rightArrow: rightArrow,
  backsvg: backsvg,
  backward: backward,
  userDouble: userDouble,
  settings: settings,
  privacyPolicy: privacyPolicy,
  giftBox: giftBox,
  megaphone: megaphone,
  qa: qa,
  lifePreserver: lifePreserver,
  login: login,
  exit: exit,
  about: about,
  customerService: customerService,
  whatsappline: whatsappline,
  iIcon: iIcon,
  infoIcon: infoIcon,
  editSVG: editSVG,
  favouritesSVG: favouritesSVG,
  userSVG: userSVG,
  party: party,
  packageSVG: packageSVG,
  interview: interview,
  shareSVG: shareSVG,
  deleteSVG: deleteSVG,
  alert: alert,
  verticalMenuSVG: verticalMenuSVG,
  service: service,
  likebkg: likebkg,
  shoppingCart: shoppingCart,
  location: location,
  whatsapp: whatsapp,
  ticket: ticket,
  likehrt: likehrt,
  logo: logo,
  medicationSVG: medicationSVG,
  OPDSVG: OPDSVG,
  pastHistorySVG: pastHistorySVG,
  vaccineSVG: vaccineSVG,
  reportsSVG: reportsSVG,
  virusSVG: virusSVG,
  deadbodySVG: deadbodySVG,
  procedureSVG: procedureSVG,
  adviceProcedureSVG: adviceProcedureSVG,
  wrongAccess: wrongAccess,
  lefrArrowSVG: lefrArrowSVG,
  saveSVG: saveSVG,
  walletSVG: walletSVG,
  crossSVG: crossSVG,
  linkSVG: linkSVG,
  disconnectedChains: disconnectedChains,
  downArrow: downArrow,
  moneySVG: moneySVG,
  billSVG: billSVG,
  money2SVG: money2SVG,
  incomeSvg: incomeSvg,
  successcheckSVG: successcheckSVG,
  walletSolid: walletSolid,
  printerSolid: printerSolid,
  cancelSolid: cancelSolid,
  locationSVG: locationSVG,
  instagramSVG: instagramSVG,
  twitterSVG: twitterSVG,
  facebookSVG: facebookSVG,
  homeSVG: homeSVG,
  rightarrowSVG: rightarrowSVG,
  emailSVG: emailSVG,
  filterSVG: filterSVG,
  testSVG: testSVG,
  trivendrumSVG: trivendrumSVG,
  whochartSVG: whochartSVG,
  headphoneSVG: headphoneSVG,
  alarmheadSVG: alarmheadSVG,
  notificationSVG: notificationSVG,
  shoppingCartSVG: shoppingCartSVG,
  downSVG: downSVG,
  apple: apple,
  android: android,
  microphoneSolid: microphoneSolid,
  microphoneOff: microphoneOff,
  videoCamera: videoCamera,
  videoCameraSolid: videoCameraSolid,
  calculatorSVG,
  dependentSVG,
  gallerySVG,
  alarmSVG,
  stationaryBikeSVG,
  reviewsSVG,
  calenderSVG,
  personelSVG,
  onlineConsultationSVG,
  ordersSVG,
  flagSVG,
  medicalAccountsSVG,
  dashboardFavourites,
  homeVisitSVG,
  mygallery,
  patientgallery,
  eventsSVG,
  ipdSVG,
  fileSVG,
  workingDiagnosisSVG,
  pdfSVG,
  attachmentSVG,
  subscriptionMonthly,
  subscriptionHalfYear,
  subscriptionYearly,
  subscriptionGiftBox,
  CallIconSVG,
  ChatBubbleSVG,
  euthanasiaSVG,
  newAlertSVG,
  dangerAlertSVG,
  healthinsuranceSVG,
  keySVG,
  privacySVG,
  fileLockSVG,
  signatureSVG,
  securitySVG,
  databaseSVG,
  manageProfilesettingsSVG,
  daySVG,
  pharmacyRecord,
  shoppingBagSVG,
  facebook,
  twitterLogo,
  linkedin,
  bloggerLogo,
  sharingSVG,
  ReferAndEarnSVG,
  onlineStore,
  oxygenSVG,
  digitalSignatureSVG,
  privacydocSVG,
  requestlogInfoSVG,
  manageProfileSVG,
  subscriptionBoxSVG,
  blogSVG,
  dependentsSVG,
  clone,
  newAB,
  newAlliedBlack,
  totalPendingCenterSVG,
  expiredCenterSVG,
  subscribedCenterSVG,
  totalAcceptedCenterSVG,
  totalUnsubscribedCenterSVG,
  heartWithPlus,
  leftArrowCircleSVG,
  rightArrowCircleSVG,
  starOutlineSVG,
  rightArrowCircleSolidSVG,
  leftArrowCircleSolidSVG,
  hospitalBed,
  checkarrowSVG,
  userblockSVG,
  filterblocksSVG,
  arrowrightSVG,
  patientleftarrowSVG,
  patientrightarrowSVG,
  hairfallSVG,
  cardioSVG,
  periodSVG,
  backpainSVG,
  abdomenSVG,
  depressionSVG,
  aciditygasSvg,
  colorCalendarSVG,
  colorOnlineSVG,
  colorMedicalSVG,
  colorhealthSVG,
  colorGallerySVG,
  colorMedicalHistorySVG,
  colorMedicalAssistanceSVG,
  colorFlagSVG,
  colorBloggerSVG,
  colorTestSVG,
  colorWalletSVG,
  colorTemplateSVG,
  colorRatingSVG,
  newCOC,
  colorBloodSVG,
  colorPharmacySVG,
  colorTestsSVG,
  colorDoctorSVG,
  colorDiagnosticSVG,
  colorAmbulanceSVG,
  colorPersonalSVG,
  // colorCalculatorSVG
  colorShopCartSVG,
  colorGrievanceSVG,
  colorWalletTransSVG,
  colorcampaignTransSVG,
  colorEnrolledSVG,
  colorfavouriteSVG,
  myGallerySVG,
  patientGallerySVG,
  homeTabSVG,
  colordependentSVG,
  editIconSVG,
  colorWardSVG,
  colorCenterSVG,
  colorOwnerSVG,
  newLoginSVG,
  newDocumentSVG,
  newHelpSVG,
  newNotificationSVG,
  newPolicySVG,
  newPromotionSVG,
  newSettingSVG,
  newTCSVG,
  newGuideSVG,
  newOtherSVG,
  newManSVG,
  newWomenSVG,
  newPendingSVG,
  newSubscribedSVG,
  newExpiredSVG,
  newAcceptedSVG,
  newUnSubscribedSVG,
  newCompletedSVG,
  LoginImage,
  dotImage,
  colorTeamworkSVG,
  newFAQSVG,
  onboardingSVG,
  newSubSVG,
  newDocIconSVG,
  newQrCode,
  newSignature,
  newServer,
  newManagePassword,
  newSettings,
  newSubscription,
  newrequestInfo,
  newplan,
  newpremium,
  newsecurity,
  newsubcriptionmonthly,
  newsubcriptionhalf,
  newsubcriptionyearly,
  newpdf,
  newhealthpackage,
  newgallerybox,
  newpatientdead,
  newOPD,
  newMedicalCertificate,
  newMedications,
  newMedicalHistory,
  newMedicalDiagnosis,
  newProcedure,
  payPerUse,
  newExcel,
  newBlood,
  newHospital,
  newColorFitness,
  newColorCustom,
  newColorTreatment,
  newEmptyPayPerUse,
  // newEmptyPayVue,
  sharingNew,
  vaccineNSVG,
  newShowCalendarSVG,
  paymentHistorySVG,
  newMR,
  newVisitor,
  newImmediateOPD,
  newWaitingArrowSVG,
  newdesignDoctorSVG,
  newdesignHospitalSVG,
  newdesignDiagnosticSVG,
  newdesignPharmacySVG,
  newdesignAmbulanceSVG,
  newdesignBloodbankSVG,
  newdesignSalesServiceSVG,
  newNoDataSVG,
  newPageNotFoundSVG,
  switchParentSVG,
  newComingSoonSVG,
  newEmptySVG,
  newColorUploadSVG,
  newCapturePresctionSVG,
  onlineShopSVG,
  team2SVG,
  billLinkSVG,
  newRefreshSVG,
  featureSVG,
  colorCalcSVG,
  questionSVG,
  newVerifyOtpSVG,
  newCOCSVG,
  newAlliedBlackIcon,
  newAlliedBlackShape,
  newAlliedColorShape,
  newAppointList,
  newAppointActiveList,
  newAppointActiveCalendar,
  conversation,
  groupChat,
  teamChat,
  profilechat,
  newAllergy,
  newBlackDoc,
  newEud,
  newAppropriate,
  newOrganDonor,
  newZoomInSVG,
  newZoomOutSVG,
  newNetworkSVG,
  newCurrentBooking,
  newCompletedBooking,
  newCancelledBooking,
  hospitalClinic,
  group1,
  writtenConversation,
  warningSVG,
  information,
  logout,
  colorDoctor,
  colorPharmacy,
  colorDiagnostics,
  colorHospital,
  colorBlood,
  colorAmbulance,
  group1405,
  group1420,
  group1984,
  drugSvg,
  medicineSvg,
  searchMedicinePill,
  newPharmacySearchSVG,
  emptyMedicineSVG
};

let pickSvg = (...args) => {
  let wrap = ({ ...args }) => ({ ...args });
  return wrap(svgRegistries);
};

export { pickSvg, svgRegistries };
